import { browserSupportsWebAuthn, startAuthentication, startRegistration, WebAuthnError } from '@simplewebauthn/browser';

/**
 * The single place the console talks to `navigator.credentials` (T460-1-4):
 * the API hands out WebAuthn options as JSON, the browser library turns them
 * into a credential and back. Tests replace this module.
 */
export const passkeysSupported = (): boolean => browserSupportsWebAuthn();

export const createPasskey = (options: Record<string, unknown>) => startRegistration({ optionsJSON: options as never });

export const getPasskeyCredential = (options: Record<string, unknown>) => startAuthentication({ optionsJSON: options as never });

export type PasskeyErrorKind = 'cancelled' | 'duplicate' | 'failed';

/** `cancelled` when the person closed the browser dialog or it timed out, `duplicate` when this device already holds one for the account. */
export function passkeyErrorKind(error: unknown): PasskeyErrorKind {
  if (error instanceof WebAuthnError && error.code === 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED') return 'duplicate';
  const name = (error as Error | undefined)?.name;
  return name === 'NotAllowedError' || name === 'AbortError' ? 'cancelled' : 'failed';
}
